import { render, staticRenderFns } from "./ModalAddPrivilegeDetail.vue?vue&type=template&id=fbe7db14&scoped=true&"
import script from "./ModalAddPrivilegeDetail.vue?vue&type=script&lang=js&"
export * from "./ModalAddPrivilegeDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddPrivilegeDetail.vue?vue&type=style&index=0&id=fbe7db14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe7db14",
  null
  
)

export default component.exports